<template>
  <!-- THEME -->
  <v-app dark>
    <!--  <div class="betaStamp"></div> -->

    <!-- DRAWER -->
    <!-- <drawer :show="drawer" @closeDrawer="drawer = false" /> -->

    <!-- Toolbar -->
    <!-- <toolbar :show="toolbarComputed" @showDrawer="drawer = true" /> -->

    <!-- SCROLL ARROW -->
    <!-- <scroll-arrow :show="showArrow" :scroll-end="scrollEnd" /> -->

    <!-- CONTENT -->
    <main>
      <v-container>
        <router-view ref="dog" />
      </v-container>
    </main>
    <!-- DIALOGS -->
    <message-dialog />
  </v-app>
</template>

<script>
// import { mapGetters } from "vuex";
// import Drawer from "./components/navigation/Drawer";
// import Toolbar from "./components/navigation/Toolbar";
// import ScrollArrow from "./components/navigation/ScrollArrow";
import MessageDialog from "./components/MessageDialog";

export default {
  components: {
    // Drawer,
    // Toolbar,
    // ScrollArrow,
    MessageDialog
  },
  data() {
    return {
      // drawer: null,
      // scrollEnd: false,
      // showArrow: false,
      // bodyScroll: null,
      // windowScroll: null,
      // backStyle: ""
    };
  },
  computed: {
    // toolbarComputed() {
    //   if (this.$store.getters.getPlayer !== null) {
    //     if (
    //       this.$route.path.substr(1) === "Splash" ||
    //       this.$route.path.substr(1) === "Loading" || 
    //       this.$route.path.substr(1) === "Player" || 
    //       this.$route.path.substr(1) === "Likes"
    //     ) {
    //       return false;
    //     } 
    //     return true;
        
    //   }
    //   return false;
    // }
  },
  // mounted() {
  //   // SCROLL PROCESSING
  //   this.bodyScroll = document.body;
  //   this.windowScroll = window;

  //   this.windowScroll.onscroll = () => {
  //     const x =
  //       this.bodyScroll.scrollHeight -
  //       this.windowScroll.innerHeight -
  //       this.windowScroll.scrollY;
  //     if (x === 0) {
  //       this.scrollEnd = true;
  //     } else {
  //       this.scrollEnd = false;
  //     }
  //   };

  //   function onElementHeightChange(elm, callback) {
  //     let lastHeight = elm.clientHeight,
  //       newHeight;
  //     (function run() {
  //       newHeight = elm.clientHeight;
  //       if (lastHeight !== newHeight) callback();
  //       lastHeight = newHeight;

  //       if (elm.onElementHeightChangeTimer)
  //         clearTimeout(elm.onElementHeightChangeTimer);

  //       elm.onElementHeightChangeTimer = setTimeout(run, 200);
  //     }());
  //   }

  //   onElementHeightChange(document.body, () => {
  //     if (document.body.offsetHeight > 1080) {
  //       this.showArrow = true;
  //     } else {
  //       this.showArrow = false;
  //     }
  //   });

  //   const lang = localStorage.getItem("virtual-app-lang");
  //   if (lang) this.$i18n.locale = lang;
  //   else {
  //     const multiLang = localStorage.getItem("vue-lang");
  //     if (multiLang) this.$i18n.locale = lang;
  //   }
  // },
  // updated() {
  //   if (this.$route.path.substr(1) === "Category") {
  //     this.backStyle =
  //       `background: linear-gradient(#303030 50%,${ 
  //         this.$store.getters.getCurrentCategory.accent 
  //       })`;
  //   } else {
  //     this.backStyle = "background: #303030!important;";
  //   }
  // }
};
</script>


<style >
/* .betaStamp {
  height: 70px !important;
  width: 150px !important;
  background-image: url("/static/images/random/betaStamp.png");
  background-size: contain !important;
  position: absolute;
  top: 30px;
  right: 225px;
  z-index: 999;
}

#carousel-img {
  height: 100% !important;
  width: 100% !important;
  background-size: cover !important;
}

OVERWRITE IN MIN.JS FILE @NODE_MODULES
.carousel-3d-slide {
  background: none !important;
}

#selector .carousel-3d-slide {
  filter: brightness(50%);
  background-color: none !important;
}

#selector .carousel-3d-slide.current {
  filter: none;
}

#selector .prev {
  margin-top: 5px;
  font-size: 50px !important;
  left: 25% !important;
}

#selector .next {
  margin-top: 5px;
  font-size: 50px !important;
  right: 25% !important;
}

.userStats {
  position: relative;
}

.ew-logo-small {
  bottom: 0px;
  position: absolute;
}

.navigation-drawer {
  width: 400px !important;
}

.navigation-drawer--close:not(.navigation--permanent).navigation-drawer:not(.navigation-drawer--right) {
  transform: translate3d(-400px, 0, 0) !important;
}

.navigation-drawer__border {
  width: 0 !important;
}

.navigation-drawer > .list .list__tile--active > *:first-child .icon {
  color: cornflowerblue;
}

.navigation-drawer > .list .list__tile--active .list__tile__title {
  color: cornflowerblue !important;
}

.list__tile {
  height: 70px;
}

.list__tile__title {
  height: 70px;
  line-height: 65px;
}

.toolbar__content {
  height: 100px !important;
}

.tool-color {
  background-color: #303030 !important;
}

.carousel-3d-slide {
  background: none !important;
  opacity: 0.3 !important;
}

.disabledArrows {
  filter: brightness(25%);
  font-size: 50px;
}

.dynamicGrad {
  background: linear-gradient(#303030, red) !important;
}

.classBarN {
  width: 90%;
  height: 8px;
  border-radius: 25px;
  background-color: red;
  box-shadow: 0px 4px 15px black;
  margin: 0 auto !important;
} */
body {
  scroll-behavior: smooth;
}
</style>


// WEBPACK FOOTER //
// src/App.vue